<template>

<div class="inputs">
	
	<slot></slot>
	
</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.inputs {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
    margin: 10px;
}

.inputs >>> .group {
    border-bottom: 1px solid #2b5870;
}

.inputs >>> .input:last-child,
.inputs >>> .group:last-child {
    border-bottom: 0px;
}

.inputs >>> .input.is-inline, 
.inputs >>> .input.is-inset {
    margin: 0px;
}

.inputs >>> .input.is-inline input, 
.inputs >>> .input.is-inset input {
    background-color: transparent;
    padding: 0px;
    margin: 0px;
    font-size: 14px;
    height: 20px;
}

.inputs >>> .input.is-inline input::placeholder, 
.inputs >>> .input.is-inset input::placeholder {
    color: #8098a5;
}

</style>
